import { useUserContext } from "api/user/UserProvider";
import "pages/RestrictedAccessPage.scss";
import { FormattedMessage } from "react-intl";
import { getDefaultRoutes } from "utils/helper";
import Button from "core/buttons/button/Button";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const RestrictedAccessPage = ({ urlWithoutScope, restrictedAccessScope }) => {
  const navigate = useNavigate();
  const { userScope, userRoleList } = useUserContext();
  const defaultRoute = getDefaultRoutes(userRoleList);

  useEffect(() => {
    if (restrictedAccessScope !== userScope) {
      navigate(`/${userScope}/${urlWithoutScope}`);
    }
  }, [userScope]);

  return (
    <div className="unauthorized-page">
      <div className="image image-scope-not-found" />
      <div className="content">
        <div className="error-restriction">
          <FormattedMessage id="restricted" defaultMessage="Accès Restreint" />
        </div>
        <div className="error-message">
          <FormattedMessage
            id="access_message"
            defaultMessage="Accès non autorisé au profil utilisateur."
          />
        </div>
        <div className="error-message">
          <FormattedMessage
            id="restricted-access-error-message"
            defaultMessage="Veuillez vérifier votre scope."
          />
        </div>
        <Button
          color="btn-standard gray-700"
          type="link"
          to={`/${userScope}${defaultRoute}`}
        >
          <FormattedMessage
            id="back_to_home_page"
            defaultMessage="Retour sur la page d'accueil"
          />
        </Button>
      </div>
    </div>
  );
};

export default RestrictedAccessPage;
